import UserForm from "./UserForm";
import useUsers from "./useUsers";
import ListingCardWrapper from "../listingCard/ListingCardWrapper";
import ListingCardPagination from "../listingCard/ListingCardPagination";
import ListingCardHeader from "../listingCard/ListingCardHeader";
import ListingCardTable from "../listingCard/ListingCardTable";
import { useSelector } from "react-redux";
import XButton from "../common/XButton";
import { rowActionCellClasses } from "../common/caseListClasses";

const Users = () => {
    const { isAdmin = false } = useSelector((state) => state.users || {});

    const {
        handleSearchChange, 
        openAddUserModal, 
        handleEdit, 
        usersList,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal,
        closeModal,
        isFormSubmitting,
        onSubmit,
        selectedUserId
    } = useUsers();

    const userTableHeaders = [
        {
            label: 'Name',
            field: 'name',
            sortKey: 'firstName.lastName',
            render: (user) => <span>{user?.firstName} {user?.lastName}</span>
        },
        {
            label: 'Email Address',
            field: 'email',
            sortKey: 'email',
        },
        {
            label: 'Phone Number',
            field: 'mobileNumber',
            sortKey: 'mobileNumber',
        },
        ...(isAdmin ? [{
            label: '',
            field: 'actions',
            render: (user) => (
                <div className={rowActionCellClasses}>
                    <XButton variant="rowAction" onClick={() => handleEdit(user)}>
                        <i className="fa-solid fa-pen"></i> Edit
                    </XButton>
                </div>
            )
        }] : [])
    ];

    return (
        <ListingCardWrapper>
            <ListingCardHeader
                title={'Users'}
                handleSearchChange={handleSearchChange}
                btnText={isAdmin ? "Add User" : null}
                onBtnClick={openAddUserModal}
            />

            <ListingCardTable
                tableHeaders={userTableHeaders}
                list={usersList}
            />

            <ListingCardPagination
                dataLimit={limit}
                setDataLimit={setLimit}
                totalCount={totalCount}
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />

            {isShowModal && (
                <UserForm
                    isOpen={isShowModal}
                    title={selectedUserId ? 'Edit User' : 'Add User'}
                    onClose={closeModal}
                    isFormSubmitting={isFormSubmitting}
                    onSubmit={onSubmit}
                    selectedUserId={selectedUserId}
                />
            )}
        </ListingCardWrapper>
    )
}

export default Users;